export default __webpack_public_path__ + "static/img/8.af69503.png";